export const MemberDayTagName = 'Member Offer Day';

export const MemberDayTagNames = ['Member Offer Day', 'Día Livli Family'];

export const isMemberDayTag = (tag: string): boolean =>
  MemberDayTagNames.some(
    (name) => name.toLowerCase() === tag?.toLowerCase()?.trim(),
  );
